import React from 'react'
import Typography from '@mui/material/Typography'
import PlastiqPriorityLogo from '../../assets/icons/PlastiqPriorityLogo'

export interface WorkflowDevFooterProps {
  sx?: object
}

const WorkflowDevFooter = (props: WorkflowDevFooterProps) => {
  return (
    <footer
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Typography
        component='span'
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
          textTransform: 'uppercase',
          fontSize: '0.625rem',
          fontWeight: '600',
          lineHeight: '1.6',
          textAlign: 'center',
          ...props.sx,
        }}
      >
        powered by <PlastiqPriorityLogo />
      </Typography>
    </footer>
  )
}

export default WorkflowDevFooter
